<template>
  <div class="five">
    <div class="title"></div>
    <div class="box">
      <div class="swiper-container pic_swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../../assets/img/five/1.png" alt />
            <i></i>
          </div>
          <div class="swiper-slide">
            <img src="../../assets/img/five/2.png" alt />
            <i></i>
          </div>
          <div class="swiper-slide">
            <img src="../../assets/img/five/3.png" alt />
            <i></i>
          </div>
          <div class="swiper-slide">
            <img src="../../assets/img/five/4.png" alt />
            <i></i>
          </div>
          <div class="swiper-slide">
            <img src="../../assets/img/five/5.png" alt />
            <i></i>
          </div>
          <div class="swiper-slide">
            <img src="../../assets/img/five/6.png" alt />
            <i></i>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev prev"></div>
      <div class="swiper-button-next next"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import { mapGetters } from 'vuex'
export default {
  name: 'five',
  components: {},
  data () {
    return {
      mySwiper: ''
    }
  },
  computed: {
    ...mapGetters(['user_agent'])
  },
  mounted () {
    this.swiperInit()
  },
  methods: {
    swiperInit () {
      this.mySwiper = new Swiper('.pic_swiper', {
        observer: true,
        observeParents: true,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        autoplay: 3000,
        loop: true,
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        coverflow: {
          rotate: 0,
          stretch: 0,
          depth: this.user_agent ? 280 : 500,
          modifier: 1,
          slideShadows: true
        },
        prevButton: '.prev',
        nextButton: '.next',
        pagination: '.swiper-pagination'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.five {
  position: relative;
  left: 0;
  right: 0;
  width: 100vw;
  height: 900px;
  background: url("../../assets/img/five/pc.jpg") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.title {
  width: 579px;
  height: 64px;
  margin: 40px auto;
  background: url("../../assets/img/five/title.png") no-repeat;
  background-size: 100%;
}
.box {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.swiper-container {
  width: 860px;
  height: 680px;
  margin-top: 30px;
  padding: .5rem 0 0 0;
}
.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 326px;
  height: 580px;
  i {
    position: absolute;
    top: 0;
    left: 50%;
    display: none;
    width: 105%;
    height: 102%;
    -webkit-transform: translate(-50%, -1%);
    transform: translate(-50%, -1%);
    z-index: 0;
    background: url("../../assets/img/five/border.png") no-repeat center;
    background-size: auto 100%;
  }
}
.pic_swiper /deep/ .swiper-slide-shadow-left {
  background-image: linear-gradient(
    to left,
    rgb(12, 12, 12),
    rgba(11, 11, 11, 0.53)
  ) !important;
}
.pic_swiper /deep/ .swiper-slide-shadow-right {
  background-image: linear-gradient(
    to left,
    rgb(12, 12, 12),
    rgba(11, 11, 11, 0.53)
  ) !important;
}
.pic_swiper /deep/ .swiper-slide-active {
  i {
    display: block;
  }
}

.pic_swiper /deep/ span.swiper-pagination-bullet {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../../assets/img/five/unchecked.png") no-repeat;
  background-size: 100% 100%;
}
.pic_swiper
  /deep/
  span.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: url("../../assets/img/five/checked.png") no-repeat;
  background-size: 100% 100%;
}
.box /deep/.swiper-button-prev, .box /deep/.swiper-button-next {
  background: none;
}
.box /deep/ .swiper-button-prev:after {
  content: "";
  width: 41px;
  height: 41px;
  background: url("../../assets/img/five/right.png") no-repeat;
  background-size: 100%;
  position: absolute;
}
.box /deep/ .swiper-button-next:after {
  content: "";
  width: 41px;
  height: 41px;
  background: url("../../assets/img/five/left.png") no-repeat;
  background-size: 100%;
  position: absolute;
}

@media screen and (max-width: 640px) {
  .five {
    position: relative;
    left: 0;
    right: 0;
    width: 100vw;
    height: 9.39rem;
    background: url("../../assets/img/five/phone.jpg") no-repeat;
    background-size: 100% 100%;
  }
  .title {
    width: 5.79rem;
    height: 0.64rem;
    margin: 0.4rem auto;
    background: url("../../assets/img/five/title.png") no-repeat;
    background-size: 100%;
  }
  .box {
    width: 100vw;
    margin: 0 auto;
  }
  .swiper-container {
    width: 100vw;
    height: 6.8rem;
    margin-top: 0.3rem;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 3.26rem;
    height: 5.81rem;
  }
  .swiper-container-3d {
    perspective: 12rem;
  }
  .swiper-container img {
    width: 3.26rem;
    //  height: 5.81rem;
  }
}
</style>
